import { defaultColors } from 'HelperFiles/Constants';
import React from 'react';
import { Chart } from "react-google-charts";

const DoriDonutChart = ({
  chartData = [],
  height = '',
  width = '',
  showLegend = true,
  title = '',
  chartColors = null,
  chartType = 'PieChart',
  pieHole = 0.4,
}) => {
  
  return (
    <Chart
      chartType={chartType}
      data={chartData}
      height={height}
      width={width}
      options={{
        is3D: false,
        title,
        legend: showLegend ? '' : 'none',
        pieHole: chartType === 'PieChart' ? 0 : pieHole,
        colors: chartColors || defaultColors,
        chartArea: { left: 10, top: 10, width: "80%", height: "80%" },
      }}
    />
  );
}

export default DoriDonutChart;
